module.exports = __webpack_public_path__ + "img/flag_cs.aa32430a.png";